import i18n from "../i18n";
import { store } from "../store";
import { resetProfileData } from "../store/profileDataSlice";
import { resetQuizPathProgress } from "../store/quizPathProgressSlice";
import { setUserAuthInfo, setUserData } from "../store/userInfoSlice";
import { clearToken } from "./authUtils";
import { showToast } from "./toast";
import { queryClient } from "../queryClient";

const PUBLIC_AUTH_PATHS = new Set([
  "/",
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
]);

let stopTokenRefreshFn: (() => void) | null = null;
let isHandlingSessionExpired = false;

export const registerStopTokenRefresh = (fn: () => void): void => {
  stopTokenRefreshFn = fn;
};

const shouldRedirectToLogin = (): boolean => {
  if (typeof window === "undefined") return false;
  return !PUBLIC_AUTH_PATHS.has(window.location.pathname);
};

const clearClientAuthState = (): void => {
  stopTokenRefreshFn?.();
  clearToken();
  store.dispatch(setUserData(null));
  store.dispatch(setUserAuthInfo(null));
  store.dispatch(resetProfileData());
  store.dispatch(resetQuizPathProgress());
  queryClient.removeQueries({ queryKey: ["userStats"] });
  queryClient.removeQueries({ queryKey: ["profileItems"] });
};

export const handleSessionExpired = (): void => {
  if (isHandlingSessionExpired) return;
  isHandlingSessionExpired = true;

  clearClientAuthState();
  showToast(i18n.t("sessionExpired", { ns: "common" }));

  if (shouldRedirectToLogin()) {
    window.location.href = "/login";
    return;
  }

  isHandlingSessionExpired = false;
};
